import { IdEpiNavigation } from "../../interfaces/serviceModels/IRequestJSON";
import { setEPICONTENTOBJECT } from "../constants/epiContentObject.types";

export const setEpiContentObject = (epiObject: IdEpiNavigation) => {
  return {
    type: setEPICONTENTOBJECT,
    payload: epiObject,
  };
};
